import { render, staticRenderFns } from "./ysxy.vue?vue&type=template&id=d3b7db0e&scoped=true&"
import script from "./ysxy.vue?vue&type=script&lang=js&"
export * from "./ysxy.vue?vue&type=script&lang=js&"
import style0 from "./ysxy.vue?vue&type=style&index=0&id=d3b7db0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3b7db0e",
  null
  
)

export default component.exports